import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { useBoundStore } from 'useStore';
import fetchForecastHistoryData from '../services/fetchForecastHistoryData';
import useCurrentMasterCountry from 'views/Components/Shared/hooks/useCurrentMasterCountry';
import useCountriesData from 'views/Components/Shared/Queries/countriesQuery';

export default function useForecastHistoryData() {
	const { accessToken } = useAuth();
	const paginationModel = useBoundStore((state) => state.fhPaginationModel);
	const countriesQuery = useCountriesData();
	const currentMasterCountry = useCurrentMasterCountry();
	const countryId = currentMasterCountry?.id;

	const selectedOwner = useBoundStore((state) => state.fhSelectedOwner);
	const selectedDate = useBoundStore((state) => state.fhSelectedDate);
	const search = useBoundStore((state) => state.fhSearch);
	const selectedMotive = useBoundStore((state) => state.fhMotive);
	const selectedMargin = useBoundStore((state) => state.fhMargin);
	const selectedYear = useBoundStore((state) => state.fhSelectedYear);
	const selectedMarketplace = useBoundStore(
		(state) => state.fhSelectedMarketplace
	);

	const forecastHistoryQuery = useQuery({
		queryKey: [
			'forecastHistory',
			{
				page: paginationModel.page,
				pageSize: paginationModel.pageSize,
				countryId,
				selectedOwner,
				selectedDate,
				search,
				selectedMotive,
				selectedMargin,
				selectedYear,
				selectedMarketplace,
			},
		],
		queryFn: () =>
			fetchForecastHistoryData({
				accessToken,
				page: paginationModel.page,
				pageSize: paginationModel.pageSize,
				countryId,
				selectedOwner,
				selectedDate,
				search,
				selectedMotive,
				selectedMargin,
				selectedYear,
				selectedMarketplace,
			}),
		staleTime: Infinity,
		retry: false,
		enabled: !!countryId,
		placeholderData: (previousData) => {
			return previousData;
		},
	});

	if (countriesQuery.isError) {
		throw countriesQuery.error;
	}

	return forecastHistoryQuery;
}
